import axios from "axios";
import { environment } from "../utils/environment";
import { joinUrl } from "../utils/util";

import { showGlobalToast } from "../context/ToastContext";

class ApiService {
  constructor(authProtected = true, fallbackRoute = "/login") {
    this.fallbackRoute = fallbackRoute;
    this.authProtected = authProtected;
    this.BACKEND_HOST = environment.urls.backend;
    this.FRONTEND_HOST = environment.urls.frontend;
    // TODO: Move this to environment.js or somewhere on app startup so it runs for all mandatory env variables!
    if (!this.BACKEND_HOST) {
      console.error("REACT_APP_BACKEND_HOST is not set");
      throw new Error("REACT_APP_BACKEND_HOST is not set");
    }

    if (!this.FRONTEND_HOST) {
      console.error("REACT_APP_FRONTEND_HOST is not set");
      throw new Error("REACT_APP_FRONTEND_HOST is not set");
    }
  }

  getToken() {
    return localStorage.getItem("token");
  }

  handleUnauthorized() {
    localStorage.removeItem("token");
    window.location.href = `${this.FRONTEND_HOST}${this.fallbackRoute}`;
  }

  async _call(method, url, data) {
    const axios_params = {
      method,
      url: joinUrl(this.BACKEND_HOST, url),
      data,
    };

    if (this.authProtected) {
      const token = this.getToken();
      if (token) {
        axios_params.headers = {
          Authorization: `Bearer ${token}`,
        };
      } else if (this.fallbackRoute) {
        this.handleUnauthorized();
      }
    }

    try {
      return await axios.request(axios_params);
    } catch (error) {
      const detail = error?.response?.data?.detail;

      if (error.response && error.response.status === 401) {
        if (this.authProtected && this.fallbackRoute) this.handleUnauthorized();
      }

      if (detail) {
        showGlobalToast(detail);
      }

      throw error;
    }
  }

  _get(url, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const fullUrl = queryString ? `${url}?${queryString}` : url;
    return this._call("get", fullUrl);
  }

  _put(url, data = {}) {
    return this._call("put", url, data);
  }

  _post(url, data = {}) {
    return this._call("post", url, data);
  }

  _delete(url, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const fullUrl = queryString ? `${url}?${queryString}` : url;
    return this._call("delete", fullUrl);
  }
}

export default ApiService;
